import React, { Component } from "react";

import { Content } from "../components";

class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opacity: 1,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = (evt) => {
    if (!this.props.loading) {
      let targ = this.refs.project;
      let y = window.scrollY;

      let rect = targ.getBoundingClientRect();
      let top = rect.top + y;
      let bottom = top + rect.height;
      let wh = window.innerHeight;
      let start = y + wh;

      /*console.log({
				top: top,
				bottom: bottom,
				start: start
			})*/

      if (start > bottom) {
        // animate space opacity

        let diff = start - bottom;
        let percentage = 100 - (diff / wh) * 100;
        let opacity = Math.round(percentage) / 100;

        this.setState({
          opacity: opacity,
        });
      }
    }
  };

  render() {
    let { entry, loading } = this.props;

    //if(!entry) return null

    if (loading) return <div className="Project Project--loading" />;

    return (
      <div
        className="Project Project--page"
        data-project={entry.id}
        ref="project"
      >
        <div className="Project-head">
          {" "}
          <h1> {entry.title}</h1>
        </div>

        <div className="Project-intro">
          <h1> {entry.intro} </h1>
        </div>

        <div className="Project-body">
          <Content modifier="text" html={entry.text} />
        </div>

        <div
          className="Project-spacer"
          style={{ opacity: this.state.opacity }}
        />
      </div>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/js/components/Page.jsx